import useSEO from "@/hooks/useSEO";
import LegalLayout from "./LegalLayout";
import { COMPANY } from "@/config/site";

export default function MentionsLegales() {
  useSEO({
    title: "Mentions légales",
    description:
      "Mentions légales de PENOW — plateforme de mise en relation à Fondettes (37230). Éditeur, hébergeur, directeur de publication, propriété intellectuelle.",
    path: "/mentions-legales",
  });

  return (
    <LegalLayout
      title="Mentions légales"
      subtitle="Conformément à l'article 6-III de la loi n°2004-575 du 21 juin 2004 pour la Confiance dans l'Économie Numérique (LCEN)."
      updatedAt="Décembre 2025"
    >
      <div className="callout" style={{ background: "#FFF5F0", borderLeftColor: "#C05C3D" }}>
        <strong>PENOW — Apporteur d'affaires</strong>
        <br />
        PENOW est une plateforme de <strong>mise en relation</strong> entre
        clients et professionnels partenaires du bâtiment. PENOW n'exécute
        aucune prestation technique de rénovation ou d'installation, n'est ni
        constructeur ni artisan, et n'agit pas comme mandataire des
        professionnels partenaires.
      </div>

      <h2>1. Éditeur du site</h2>
      <p>Le site <strong>penow.fr</strong> (ci-après « le Site ») est édité par :</p>
      <ul>
        <li><strong>Dénomination</strong> : {COMPANY.name}</li>
        <li><strong>Forme juridique</strong> : Entreprise individuelle</li>
        <li><strong>Siège social</strong> : {COMPANY.address}, France</li>
        <li><strong>Téléphone</strong> : {COMPANY.phone}</li>
        <li><strong>E-mail</strong> : {COMPANY.email}</li>
        <li><strong>SIRET</strong> : {COMPANY.siret}</li>
        <li><strong>Directeur de publication</strong> : Julien Peneau</li>
      </ul>

      <h2>2. Hébergement du site</h2>
      <p>Le Site est hébergé par :</p>
      <ul>
        <li><strong>Émergent</strong> — infrastructure d'hébergement Cloud</li>
        <li>Support : <a href="https://emergent.sh" target="_blank" rel="noopener noreferrer">emergent.sh</a></li>
      </ul>

      <h2>3. Propriété intellectuelle</h2>
      <p>
        L'ensemble des éléments composant le Site (textes, images, photographies,
        logos, marques, mise en page, structure, code source) est la propriété
        exclusive de {COMPANY.name} ou de ses partenaires, et est protégé par les
        lois françaises et internationales relatives à la propriété
        intellectuelle.
      </p>
      <p>
        Toute reproduction, représentation, modification, publication, adaptation
        totale ou partielle des éléments du Site, quel que soit le moyen ou le
        procédé utilisé, est strictement interdite sans autorisation écrite
        préalable de {COMPANY.name}.
      </p>

      <h2>4. Crédits</h2>
      <ul>
        <li><strong>Photographies</strong> : © {COMPANY.name} — Réalisations propres. Certaines illustrations peuvent être issues de banques d'images libres de droits.</li>
        <li><strong>Typographies</strong> : Playfair Display &amp; Manrope (SIL Open Font License, Google Fonts).</li>
        <li><strong>Icônes</strong> : Lucide React (ISC License).</li>
      </ul>

      <h2>5. Liens hypertextes</h2>
      <p>
        Le Site peut contenir des liens vers d'autres sites internet.
        {" "}{COMPANY.name} n'exerce aucun contrôle sur ces sites et décline toute
        responsabilité quant à leur contenu, leur politique de confidentialité
        ou leur utilisation.
      </p>

      <h2>6. Responsabilité</h2>
      <p>
        {COMPANY.name} s'efforce de fournir sur le Site des informations aussi
        précises que possible. Toutefois, {COMPANY.name} ne pourra être tenue
        responsable des omissions, inexactitudes ou carences dans la mise à
        jour, qu'elles soient de son fait ou du fait de tiers partenaires qui
        lui fournissent ces informations.
      </p>
      <p>
        L'utilisateur reconnaît utiliser les informations et outils mis à sa
        disposition sur le Site sous sa responsabilité exclusive.
      </p>

      <h2>7. Droit applicable et juridiction</h2>
      <p>
        Les présentes mentions légales sont régies par le droit français. En cas
        de litige et à défaut de résolution amiable, les tribunaux français
        seront seuls compétents.
      </p>

      <div className="callout">
        Pour toute question relative aux mentions légales, contactez-nous à{" "}
        <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>.
      </div>
    </LegalLayout>
  );
}
